export const validationRules = {
  required: v => !!v || 'This filed is required.',
  validEmail: v => /.+@.+/.test(v) || 'E-mail must be valid',
}
